import React, { FC, useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import {
    DefaultButton,
    PrimaryButton,
    IDropdownOption,
    MessageBarType,
    MessageBar,
    ActionButton,
    Label,
    SpinnerSize,
    Spinner,
} from '@fluentui/react';
import {
    Panel,
    Section,
    SectionSize,
    TextField,
    Dropdown,
    Form,
    ApiException,
    Language,
    requiredItem,
    LayoutContent,
    VirtualizedComboBox,
} from '@eta/components';
import { ConnectedProps, connect } from 'react-redux';
import { isNull, isNullOrUndefined } from 'util';
import NotificationDialog from './NotificationDialog';
import { ReduxState } from '../../common/reducers';
import { required } from './Validation';
import { TaxPayersGrid } from './TaxPayersGrid';
import {
    loadCurrentProfile,
    saveCurrentProfile,
    cancelModification,
    loadCurrentNotifications,
} from '../Redux/Actions';
import { loadReferenceData } from '../../ReferenceData/Redux/Action';
import './MyProfile.scss';

import {
    GetCurrentUserDetailsQueryResponseDto,
    LanguageTypes,
    TaxpayerRepresentationDto,
    TaxpayerRepresentativeDto,
    AddressViewModel,
} from '../../Services/ClientProxy/clientProxy';
import { otpVerifyUser } from '../../Verification/Redux/Actions';
import {
    Mobile,
    EmailMobile,
    Email,
} from '../../Verification/Components/index';

import {
    Defaults,
    LanguagesCodes,
    NotificationDialogResponseDelay,
} from '../../common/config/constants';
import {
    GetUserPreferenceResponse,
    NotificationTypes,
} from '../../Services/ClientProxy/NotificationManagementClient';
import { authService } from '../../Security/Security';
import ViewRepresentation from '../../TaxpayerProfile/components/ViewRepresentation';
import { RepresentationProvider } from '../../TaxpayerProfile/components/InviteUser/Context/RepresentationContext';

const emptyProfile = new GetCurrentUserDetailsQueryResponseDto();
const emptyNotification = new GetUserPreferenceResponse();

const mapStateToProps = (state: ReduxState) => ({
    currentLanguage: state.reduxlanguage.language,
    profile: state.profile.currentProfile ?? emptyProfile,
    Notification: state.profile.currentNotification ?? emptyNotification,
    lastError: state.profile.lastError,
    referenceData: state.referenceData?.taxpayersConfig
        ? {
              optionsCity:
                  state.referenceData?.taxpayersConfig?.cities?.map<IDropdownOption>(
                      (v) => {
                          return {
                              key: v.id || 0,
                              text: v.name || '',
                              data: v.parentCode || '',
                          };
                      }
                  ) ?? [],
              optionsGovernorate:
                  state.referenceData?.taxpayersConfig?.governorates?.map<IDropdownOption>(
                      (v) => {
                          return {
                              key: v.id || 0,
                              text: `${v.name}` || '',
                              data: v.code || '',
                          };
                      }
                  ) ?? [],
              optionsCountry:
                  state.referenceData?.taxpayersConfig?.countries?.map<IDropdownOption>(
                      (v) => {
                          return {
                              key: v.id || 0,
                              text: `${v.name}` || '',
                              data: `${v.code}`,
                          };
                      }
                  ) ?? [],
          }
        : null,
});
const mapDispatchToProps = {
    dispatchLoadCurrentProfile: loadCurrentProfile,
    dispatchSaveCurrentProfile: saveCurrentProfile,
    dispatchCancelModification: cancelModification,
    dispatchLoadReferenceData: loadReferenceData,
    dispatchLoadCurrentNotifications: loadCurrentNotifications,
    verify: otpVerifyUser,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;
const MyProfile: FC<PropsFromRedux> = (props: PropsFromRedux) => {
    const {
        Notification,
        profile,
        dispatchSaveCurrentProfile,
        dispatchLoadCurrentProfile,
        dispatchLoadReferenceData,
        dispatchCancelModification,
        referenceData,
        currentLanguage: propsCurrentLanguage,
        dispatchLoadCurrentNotifications,
        lastError,
    } = props;
    const [currentProfile, setCurrentProfile] = useState(
        profile.taxpayerRepresentative
    );
    const [isSaving, setIsSaving] = useState<boolean>(false);
    const [currentNotification, setCurrentNotification] = useState(
        Notification.result?.[0]
    );
    const [preferredLanguage, setPreferredLanguage] = useState<
        string | undefined
    >(profile?.preferredLanguage?.toString());

    const form = useRef(new Form({}));
    const [isFormValid, setIsFormValid] = useState<boolean>(
        form.current.isValid
    );
    const [CityFilter, setCityFilter] = useState<
        IDropdownOption[] | undefined
    >();

    form.current.onValidityChanged = (isValid) => setIsFormValid(isValid);

    const form2 = useRef(new Form({}));
    const [isFormValid2, setIsFormValid2] = useState<boolean>(
        form2.current.isValid
    );

    form2.current.onValidityChanged = (isValid) => setIsFormValid2(isValid);

    const { t } = useTranslation([
        'resources',
        'common',
        'myProfile',
        'validation',
    ]);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [currentLanguage, setCurrentLanguage] = useState<Language>();
    const [showMessageSuccess, setShowMessageSuccess] =
        useState<boolean>(false);
    const [error, setError] = useState<string>();
    const [isEditable, setEditable] = useState<boolean>(false);
    const [hiddenNotificationDialog, setHiddenNotificationDialog] =
        useState<boolean>(true);
    const [hiddenRepresentationDialog, setHiddenRepresentationDialog] =
        useState<boolean>(true);
    const [taxpayerRepresentations, setTaxpayerRepresentations] =
        useState<TaxpayerRepresentationDto[]>();
    const [, setApiErrors] = useState<ApiException>();
    const [hiddenMobileDialog, sethiddenMobileDialog] = useState<boolean>(true);
    const [hiddenMobileEmailDialog, sethiddenMobileEmailDialog] =
        useState<boolean>(true);
    const [hiddenEmailDialog, sethiddenEmailDialog] = useState<boolean>(true);
    const [notificationChannelName, setnotificationChannelName] =
        useState<string>();
    const [subscriptions, setSubscriptions] = useState<string>();
    const selectedRepresentationID = useRef<number>();

    useEffect(() => {
        if (
            referenceData === null ||
            propsCurrentLanguage !== currentLanguage
        ) {
            setCurrentLanguage(propsCurrentLanguage);
            dispatchLoadReferenceData(propsCurrentLanguage);
            dispatchLoadCurrentNotifications();
        }
        const GovernorateCode = referenceData?.optionsGovernorate.find(
            (x) =>
                x?.key ===
                profile?.taxpayerRepresentative?.address?.governorateId
        );
        const filterCity = referenceData?.optionsCity.filter(
            (item) => item?.data === GovernorateCode?.data
        );
        setCityFilter(filterCity);
    }, [
        referenceData,
        dispatchLoadReferenceData,
        dispatchLoadCurrentNotifications,
        propsCurrentLanguage,
        currentLanguage,
    ]);
    
    useEffect(() => {
        if (lastError) {
            setShowMessageSuccess(false);
        }
        setApiErrors(lastError);
        setError(lastError?.serviceError?.toString());
    }, [lastError]);

    useEffect(() => {
        if (profile === emptyProfile || currentLanguage?.lang !== propsCurrentLanguage.lang) {
            setIsLoading(true);
            dispatchLoadCurrentProfile();
        } else {
            const GovernorateCode = referenceData?.optionsGovernorate.find(
                (x) =>
                    x?.key ===
                    profile?.taxpayerRepresentative?.address?.governorateId
            );
            const filterCity = referenceData?.optionsCity.filter(
                (item) => item?.data === GovernorateCode?.data
            );
            setCityFilter(filterCity);
            setIsLoading(false);
            if (!isEditable) {
                setCurrentProfile(profile.taxpayerRepresentative);
                setPreferredLanguage(profile?.preferredLanguage?.toString());
            }
        }

        if (Notification === emptyNotification) {
            setIsLoading(true);
            dispatchLoadCurrentNotifications();
        } else {
            if (Notification) {
                setnotificationChannelName(
                    currentLanguage?.lang.startsWith('ar')
                        ? Notification?.result?.[0].notificationChannel
                              ?.nameSecondaryLang
                        : Notification?.result?.[0].notificationChannel
                              ?.namePrimaryLang
                );
                const pref =
                    Notification.result?.[0].recipientNotificationPreferences;
                const Subscriptions = [];
                if (pref && pref.length > 0) {
                    for (let i = 0; i < pref.length; i += 1) {
                        const notify = pref[i];

                        if (notify !== undefined) {
                            switch (notify.notificationTypeId) {
                                case NotificationTypes.ReceiveDownloadReady:
                                    if (notify.isSubscribed) {
                                        Subscriptions.push(
                                            t('ReceiveDownloadReady')
                                        );
                                    }
                                    break;
                                case NotificationTypes.ReceiptPackageDownloadReady:
                                    if (notify.isSubscribed) {
                                        Subscriptions.push(
                                            t('ReceiptPackageReady')
                                        );
                                    }
                                    break;
                                default:
                                    break;
                            }
                        }
                    }
                    setSubscriptions(Subscriptions.join(', '));
                } else {
                    setSubscriptions('');
                }
            }
            setIsLoading(false);
        }

        setTaxpayerRepresentations(profile.taxpayerRepresentations);
        setCurrentNotification(Notification.result?.[0]);
    }, [
        profile,
        dispatchLoadCurrentProfile,
        Notification,
        dispatchLoadCurrentNotifications,
        currentLanguage,
        propsCurrentLanguage
    ]);

    const onChangeEdit = (value: boolean) => {
        setEditable(value);
    };
    const showNotificationDialog = () => {
        setHiddenNotificationDialog(false);
    };
    const hideNotificationDialog = () => {
        setHiddenNotificationDialog(true);
    };

    const hidenMobileDialog = () => {
        sethiddenMobileDialog(true);
    };

    const hidenMobileEmailDialog = () => {
        sethiddenMobileEmailDialog(true);
        dispatchLoadCurrentProfile();
        setEditable(false);
    };

    const showEmailDialog = () => {
        sethiddenEmailDialog(false);
    };

    const hidenEmailDialog = () => {
        sethiddenEmailDialog(true);
    };

    const onSaveNotificationDialog = () => {
        setHiddenNotificationDialog(true);

        setTimeout(async () => {
            await dispatchLoadCurrentNotifications();
            setShowMessageSuccess(true);
        }, NotificationDialogResponseDelay.Delay);

        setTimeout(() => {
            setShowMessageSuccess(false);
        }, Defaults.AutoDismissPeriod);
    };

    const onSave = () => {
        setShowMessageSuccess(true);
        setHiddenNotificationDialog(true);
        sethiddenMobileDialog(true);
        sethiddenMobileEmailDialog(true);
        sethiddenEmailDialog(true);
        setEditable(false);
        setTimeout(() => {
            setShowMessageSuccess(false);
        }, Defaults.AutoDismissPeriod);
        dispatchLoadCurrentProfile();
        dispatchLoadCurrentNotifications();
    };

    const cancelForm = () => {
        setEditable(false);
        dispatchCancelModification();
    };

    const saveForm = async () => {
        setIsSaving(true);
        if (
            currentProfile?.address?.countryCode === 'EG' &&
            form.current.isValid
        ) {
            try {
                setIsLoading(true);
                const Response = await dispatchSaveCurrentProfile({
                    ...props.profile,
                    preferredLanguage:
                        preferredLanguage === LanguagesCodes.En
                            ? LanguageTypes.En
                            : LanguageTypes.Ar,
                    taxpayerRepresentative: currentProfile,
                });

                if (isNull((await Response.payload).lastError)) {
                    if (
                        currentProfile?.mobileNo !==
                            profile.taxpayerRepresentative?.mobileNo &&
                        currentProfile?.email ===
                            profile.taxpayerRepresentative?.email
                    ) {
                        sethiddenMobileDialog(false);
                    } else if (
                        currentProfile?.email !==
                            profile.taxpayerRepresentative?.email &&
                        currentProfile?.mobileNo ===
                            profile.taxpayerRepresentative?.mobileNo
                    ) {
                        showEmailDialog();
                    } else if (
                        currentProfile?.email !==
                            profile.taxpayerRepresentative?.email &&
                        currentProfile?.mobileNo !==
                            profile.taxpayerRepresentative?.mobileNo
                    ) {
                        sethiddenMobileEmailDialog(false);
                    } else {
                        setEditable(false);
                        dispatchLoadCurrentProfile();
                        setShowMessageSuccess(true);
                        setTimeout(() => {
                            setShowMessageSuccess(false);
                        }, Defaults.AutoDismissPeriod);
                    }
                }
                setIsSaving(false);
            } catch (exception) {
                setError(exception.message);
                setIsSaving(false);
            }
            setIsLoading(false);
        } else if (
            currentProfile?.address?.countryCode !== 'EG' &&
            form.current.isValid
        ) {
            try {
                setIsLoading(true);
                const Response = await dispatchSaveCurrentProfile({
                    ...props.profile,
                    preferredLanguage:
                        preferredLanguage === LanguagesCodes.En
                            ? LanguageTypes.En
                            : LanguageTypes.Ar,
                    taxpayerRepresentative: currentProfile,
                });

                if (isNull((await Response.payload).lastError)) {
                    if (
                        currentProfile?.mobileNo !==
                            profile.taxpayerRepresentative?.mobileNo &&
                        currentProfile?.email ===
                            profile.taxpayerRepresentative?.email
                    ) {
                        sethiddenMobileDialog(false);
                    } else if (
                        currentProfile?.email !==
                            profile.taxpayerRepresentative?.email &&
                        currentProfile?.mobileNo ===
                            profile.taxpayerRepresentative?.mobileNo
                    ) {
                        showEmailDialog();
                    } else if (
                        currentProfile?.email !==
                            profile.taxpayerRepresentative?.email &&
                        currentProfile?.mobileNo !==
                            profile.taxpayerRepresentative?.mobileNo
                    ) {
                        sethiddenMobileEmailDialog(false);
                    } else {
                        setEditable(false);
                        dispatchLoadCurrentProfile();
                        setShowMessageSuccess(true);
                        setTimeout(() => {
                            setShowMessageSuccess(false);
                        }, Defaults.AutoDismissPeriod);
                    }
                }
            } catch (exception) {
                setError(exception.message);
            }
            setIsLoading(false);
        }
    };

    const optionsLanguages: IDropdownOption[] = [
        { index: 1, key: LanguagesCodes.En, text: t('constants.English') },
        { index: 2, key: LanguagesCodes.Ar, text: t('constants.Arabic') },
    ];

    return (
        <LayoutContent className="myprofile" loading={isLoading}>
            {showMessageSuccess && (
                <MessageBar
                    messageBarType={MessageBarType.success}
                    isMultiline={false}
                    onDismiss={() => setShowMessageSuccess(false)}
                >
                    {t('myProfile:successSaved')}
                </MessageBar>
            )}
            {error && (
                <MessageBar
                    messageBarType={MessageBarType.error}
                    isMultiline={false}
                    onDismiss={() => setError('')}
                    className="messageBar"
                >
                    {error}
                </MessageBar>
            )}
            <Panel
                title={t('myProfile:userProfile')}
                allowEdition
                editable={isEditable}
                editTitle={t('common:edit')}
                editText={t('common:edit')}
                onChangeEdit={onChangeEdit}
                footer={(
                    <>
                        <DefaultButton
                            className="buttonCancel"
                            iconProps={{ iconName: 'Cancel' }}
                            text={t('common:cancel')}
                            onClick={() => cancelForm()}
                        />
                        <PrimaryButton
                            iconProps={{ iconName: 'Save' }}
                            text={t('common:save')}
                            onClick={() => saveForm()}
                            disabled={
                                isSaving ||
                                currentProfile?.address?.countryCode === 'EG'
                                    ? !isFormValid
                                    : !isFormValid2
                            }
                        >
                            {isSaving && <Spinner size={SpinnerSize.small} />}
                        </PrimaryButton>
                    </>
                  )}
            >
                <div className="bodyLine">
                    <TextField
                        className="test"
                        label={t('myProfile:firstName')}
                        disabled={!isEditable}
                        value={currentProfile?.firstNamePrimaryLang}
                        onChange={(_, v) =>
                            setCurrentProfile(
                                new TaxpayerRepresentativeDto({
                                    ...currentProfile,
                                    firstNamePrimaryLang: v ?? '',
                                })
                            )
                        }
                        maxLength={50}
                    />
                    <TextField
                        label={t('myProfile:surname')}
                        disabled={!isEditable}
                        value={currentProfile?.lastNamePrimaryLang}
                        onChange={(_, v) =>
                            setCurrentProfile(
                                new TaxpayerRepresentativeDto({
                                    ...currentProfile,
                                    lastNamePrimaryLang: v ?? '',
                                })
                            )
                        }
                        maxLength={50}
                    />
                    <TextField
                        label={t('myProfile:firstNameAR')}
                        required={isEditable}
                        disabled={!isEditable}
                        value={currentProfile?.firstNameSecondaryLang}
                        validationFunc={(v) =>
                            required(t, v, t('myProfile:firstNameAR'))
                        }
                        onChange={(_, v) =>
                            setCurrentProfile(
                                new TaxpayerRepresentativeDto({
                                    ...currentProfile,
                                    firstNameSecondaryLang: v ?? '',
                                })
                            )
                        }
                        onValidationChange={(isValid) => {
                            form.current.SetValidity(
                                'firstNameSecondaryLang',
                                isValid
                            );
                            form2.current.SetValidity(
                                'firstNameSecondaryLang',
                                isValid
                            );
                        }}
                        maxLength={50}
                    />
                    <TextField
                        label={t('myProfile:surnameAR')}
                        required={isEditable}
                        disabled={!isEditable}
                        value={currentProfile?.lastNameSecondaryLang}
                        onChange={(_, v) =>
                            setCurrentProfile(
                                new TaxpayerRepresentativeDto({
                                    ...currentProfile,
                                    lastNameSecondaryLang: v ?? '',
                                })
                            )
                        }
                        validationFunc={(v) =>
                            required(t, v, t('myProfile:surnameAR'))
                        }
                        onValidationChange={(isValid) => {
                            form.current.SetValidity(
                                'lastNameSecondaryLang',
                                isValid
                            );
                            form2.current.SetValidity(
                                'lastNameSecondaryLang',
                                isValid
                            );
                        }}
                        maxLength={50}
                    />
                </div>
                <div className="bodyLine">
                    <TextField
                        label={t('myProfile:nationalID')}
                        disabled
                        required={isEditable}
                        value={currentProfile?.nationalID}
                        validationFunc={(v) =>
                            required(t, v, t('myProfile:nationalID'))
                        }
                        onChange={(_, v) =>
                            setCurrentProfile(
                                new TaxpayerRepresentativeDto({
                                    ...currentProfile,
                                    nationalID: v ?? '',
                                })
                            )
                        }
                        onValidationChange={(isValid) =>
                            form.current.SetValidity('nationalID', isValid)
                        }
                        readOnly={isEditable}
                    />
                    <TextField
                        label={t('myProfile:loginEmail')}
                        disabled
                        value={authService.currentUser?.profile.name}
                    />
                    {isEditable ? (
                        <Dropdown
                            toolTip={t('myProfile:defaultLanguage')}
                            label={t('myProfile:defaultLanguage')}
                            options={optionsLanguages}
                            disabled={!isEditable}
                            selectedKey={preferredLanguage}
                            validationFunc={(v) =>
                                required(t, v, t('myProfile:defaultLanguage'))
                            }
                            onChange={(_, option) =>
                                setPreferredLanguage(
                                    option?.key
                                        ? (option.key as LanguageTypes)
                                        : LanguageTypes.None
                                )
                            }
                            onValidationChange={(isValid) =>
                                form.current.SetValidity(
                                    'preferredLanguage',
                                    isValid
                                )
                            }
                        />
                    ) : (
                        <div>
                            <div>
                                <Label>{t('myProfile:defaultLanguage')}</Label>
                            </div>
                            <TextField
                                value={
                                    preferredLanguage === LanguagesCodes.En
                                        ? t('constants.English')
                                        : t('constants.Arabic')
                                }
                                disabled
                            />
                        </div>
                    )}
                </div>
                <div className="bodyLine addressTitle">
                    <Section
                        size={SectionSize.h3}
                        title={t('myProfile:addressDetails')}
                        toolTip={t('myProfile:addressDetails_ToolTip')}
                    />
                </div>
                <div className='addressContainer'>
                    <TextField
                        disabled
                        value={
                            currentLanguage?.lang === 'en'
                                ? currentProfile?.address?.formattedAddressEn
                                : currentProfile?.address?.formattedAddressAr
                        }
                        // onChange={(_, v) => setCurrentProfile(new TaxpayerRepresentativeDto({ ...currentProfile, address:new AddressViewModel ({ ...currentProfile?.address, buildingNo: v ?? '' }) }))}
                    />
                </div>
                {isEditable && (
                    <div>
                        <div className="bodyLine">
                            <VirtualizedComboBox
                                label={t('myProfile:country')}
                                options={referenceData?.optionsCountry ?? []}
                                readOnly={!isEditable}
                                required={isEditable}
                                selectedKey={
                                    currentProfile?.address?.countryId ?? null
                                }
                                onChange={(_, option) =>
                                    setCurrentProfile(
                                        new TaxpayerRepresentativeDto({
                                            ...currentProfile,
                                            address: new AddressViewModel({
                                                ...currentProfile?.address,
                                                countryId:
                                                    Number(option?.key) ?? 0,
                                                // countryCode: option?.text.split(
                                                //     '-'
                                                // )[0],
                                                countryCode: option?.data,
                                                cityId: 0,
                                                governorateId: 0,
                                                foreignCityName: '',
                                                foreignGovernorateName: '',
                                            }),
                                        })
                                    )
                                }
                                validationFunc={(v) =>
                                    requiredItem(t, v, t('myProfile:country'))
                                }
                                onValidationChange={(isValid) => {
                                    form.current.SetValidity(
                                        'address.CountryCode',
                                        isValid
                                    );
                                    form2.current.SetValidity(
                                        'address.CountryCode',
                                        isValid
                                    );
                                }}
                                multiSelectDelimiter=""
                                allowFreeform
                                useComboBoxAsMenuWidth
                            />

                            {currentProfile?.address?.countryCode === 'EG' ? (
                                <>
                                    <VirtualizedComboBox
                                        label={t('myProfile:governorate')}
                                        options={
                                            referenceData?.optionsGovernorate ??
                                            []
                                        }
                                        readOnly={!isEditable}
                                        required={isEditable}
                                        selectedKey={
                                            currentProfile?.address
                                                ?.governorateId ?? null
                                        }
                                        onChange={(_, option) => {
                                            setCurrentProfile(
                                                new TaxpayerRepresentativeDto({
                                                    ...currentProfile,
                                                    address:
                                                        new AddressViewModel({
                                                            ...currentProfile?.address,
                                                            governorateId:
                                                                Number(
                                                                    option?.key
                                                                ) ?? 0,
                                                        }),
                                                })
                                            );
                                            const filterCity =
                                                referenceData?.optionsCity.filter(
                                                    (item) =>
                                                        item.data ===
                                                        option?.data
                                                );
                                            setCityFilter(filterCity);
                                        }}
                                        validationFunc={(v) =>
                                            requiredItem(
                                                t,
                                                v,
                                                t('myProfile:governorate')
                                            )
                                        }
                                        onValidationChange={(isValid) => {
                                            form.current.SetValidity(
                                                'address.governorateId',
                                                isValid
                                            );
                                        }}
                                        multiSelectDelimiter=""
                                        allowFreeform
                                        useComboBoxAsMenuWidth
                                    />
                                    <VirtualizedComboBox
                                        label={t('myProfile:city')}
                                        options={CityFilter ?? []}
                                        readOnly={!isEditable}
                                        required={isEditable}
                                        selectedKey={
                                            currentProfile?.address?.cityId ??
                                            null
                                        }
                                        onChange={(_, option) =>
                                            setCurrentProfile(
                                                new TaxpayerRepresentativeDto({
                                                    ...currentProfile,
                                                    address:
                                                        new AddressViewModel({
                                                            ...currentProfile?.address,
                                                            cityId:
                                                                Number(
                                                                    option?.key
                                                                ) ?? 0,
                                                        }),
                                                })
                                            )
                                        }
                                        validationFunc={(v) =>
                                            requiredItem(
                                                t,
                                                v,
                                                t('myProfile:city')
                                            )
                                        }
                                        onValidationChange={(isValid) => {
                                            form.current.SetValidity(
                                                'address.cityId',
                                                isValid
                                            );
                                        }}
                                        multiSelectDelimiter=""
                                        allowFreeform
                                        useComboBoxAsMenuWidth
                                    />
                                </>
                            ) : (
                                <>
                                    <TextField
                                        label={t('myProfile:governorate')}
                                        required={isEditable}
                                        readOnly={!isEditable}
                                        value={
                                            currentProfile?.address
                                                ?.foreignGovernorateName
                                        }
                                        onChange={(_, v) =>
                                            setCurrentProfile(
                                                new TaxpayerRepresentativeDto({
                                                    ...currentProfile,
                                                    address:
                                                        new AddressViewModel({
                                                            ...currentProfile?.address,
                                                            foreignGovernorateName:
                                                                v ?? '',
                                                        }),
                                                })
                                            )
                                        }
                                        validationFunc={(v) =>
                                            requiredItem(
                                                t,
                                                v,
                                                t('myProfile:governorate')
                                            )
                                        }
                                        onValidationChange={(isValid) => {
                                            form2.current.SetValidity(
                                                'address.foreignGovernorateName',
                                                isValid
                                            );
                                        }}
                                    />

                                    <TextField
                                        label={t('myProfile:city')}
                                        required={isEditable}
                                        readOnly={!isEditable}
                                        value={
                                            currentProfile?.address
                                                ?.foreignCityName
                                        }
                                        onChange={(_, v) =>
                                            setCurrentProfile(
                                                new TaxpayerRepresentativeDto({
                                                    ...currentProfile,
                                                    address:
                                                        new AddressViewModel({
                                                            ...currentProfile?.address,
                                                            foreignCityName:
                                                                v ?? '',
                                                        }),
                                                })
                                            )
                                        }
                                        validationFunc={(v) =>
                                            requiredItem(
                                                t,
                                                v,
                                                t('myProfile:city')
                                            )
                                        }
                                        onValidationChange={(isValid) => {
                                            form2.current.SetValidity(
                                                'address.foreignCityName',
                                                isValid
                                            );
                                        }}
                                    />
                                </>
                            )}
                        </div>

                        <div className="bodyLine">
                            <TextField
                                label={t('myProfile:building')}
                                required={isEditable}
                                readOnly={!isEditable}
                                value={currentProfile?.address?.buildingNo}
                                onChange={(_, v) =>
                                    setCurrentProfile(
                                        new TaxpayerRepresentativeDto({
                                            ...currentProfile,
                                            address: new AddressViewModel({
                                                ...currentProfile?.address,
                                                buildingNo: v ?? '',
                                            }),
                                        })
                                    )
                                }
                                validationFunc={(v) =>
                                    requiredItem(t, v, t('myProfile:building'))
                                }
                                onValidationChange={(isValid) => {
                                    form.current.SetValidity(
                                        'address.buildingNo',
                                        isValid
                                    );
                                    form2.current.SetValidity(
                                        'address.buildingNo',
                                        isValid
                                    );
                                }}
                                maxLength={50}
                            />
                            <div className="groupHorizontal">
                                <TextField
                                    label={t('myProfile:flat')}
                                    readOnly={!isEditable}
                                    value={currentProfile?.address?.flatNo}
                                    onChange={(_, v) =>
                                        setCurrentProfile(
                                            new TaxpayerRepresentativeDto({
                                                ...currentProfile,
                                                address: new AddressViewModel({
                                                    ...currentProfile?.address,
                                                    flatNo: v ?? '',
                                                }),
                                            })
                                        )
                                    }
                                    maxLength={10}
                                />
                                <TextField
                                    label={t('myProfile:floor')}
                                    readOnly={!isEditable}
                                    value={currentProfile?.address?.floorNo}
                                    onChange={(_, v) =>
                                        setCurrentProfile(
                                            new TaxpayerRepresentativeDto({
                                                ...currentProfile,
                                                address: new AddressViewModel({
                                                    ...currentProfile?.address,
                                                    floorNo: v ?? '',
                                                }),
                                            })
                                        )
                                    }
                                />
                            </div>
                        </div>

                        <div className="bodyLine">
                            <TextField
                                label={t('myProfile:streetName')}
                                readOnly={!isEditable}
                                required={isEditable}
                                value={
                                    currentProfile?.address?.streetName ?? ''
                                }
                                onChange={(_, v) =>
                                    setCurrentProfile(
                                        new TaxpayerRepresentativeDto({
                                            ...currentProfile,
                                            address: new AddressViewModel({
                                                ...currentProfile?.address,
                                                streetName: v ?? '',
                                            }),
                                        })
                                    )
                                }
                                onValidationChange={(isValid) => {
                                    form.current.SetValidity(
                                        'address.streetName',
                                        isValid
                                    );
                                    form2.current.SetValidity(
                                        'address.streetName',
                                        isValid
                                    );
                                }}
                                validationFunc={(v) =>
                                    requiredItem(
                                        t,
                                        v,
                                        t('myProfile:streetName')
                                    )
                                }
                                maxLength={100}
                            />
                        </div>
                        <div className="bodyLine">
                            <TextField
                                label={t('myProfile:street2')}
                                readOnly={!isEditable}
                                value={
                                    currentProfile?.address?.streetName2 ?? ''
                                }
                                onChange={(_, v) =>
                                    setCurrentProfile(
                                        new TaxpayerRepresentativeDto({
                                            ...currentProfile,
                                            address: new AddressViewModel({
                                                ...currentProfile?.address,
                                                streetName2: v ?? '',
                                            }),
                                        })
                                    )
                                }
                                maxLength={100}
                            />
                        </div>

                        <div className="bodyLine">
                            <TextField
                                label={t('myProfile:AdditionalInformation')}
                                readOnly={!isEditable}
                                value={
                                    currentProfile?.address
                                        ?.additionalInformation ?? ''
                                }
                                onChange={(_, v) =>
                                    setCurrentProfile(
                                        new TaxpayerRepresentativeDto({
                                            ...currentProfile,
                                            address: new AddressViewModel({
                                                ...currentProfile?.address,
                                                additionalInformation: v ?? '',
                                            }),
                                        })
                                    )
                                }
                                maxLength={500}
                            />
                        </div>
                        <div className="bodyLine">
                            <TextField
                                label={t('myProfile:PostalCode')}
                                readOnly={!isEditable}
                                value={
                                    currentProfile?.address?.postalCode ?? ''
                                }
                                onChange={(_, v) =>
                                    setCurrentProfile(
                                        new TaxpayerRepresentativeDto({
                                            ...currentProfile,
                                            address: new AddressViewModel({
                                                ...currentProfile?.address,
                                                postalCode: v ?? '',
                                            }),
                                        })
                                    )
                                }
                                maxLength={50}
                            />
                        </div>
                    </div>
                )}

                <div className="bodyLine2">
                    <div className="section">
                        <Section
                            size={SectionSize.h3}
                            title={t('myProfile:notification')}
                        />
                        <ActionButton
                            className="manage"
                            iconProps={{ iconName: 'Settings' }}
                            onClick={showNotificationDialog}
                        >
                            {t('myProfile:manage')}
                        </ActionButton>
                    </div>
                    <div className="section">
                        <Section
                            size={SectionSize.h3}
                            title={t('myProfile:notificationDelivery')}
                        />
                    </div>
                </div>
                <div className="bodyLine">
                    <TextField
                        label={t('myProfile:Channel')}
                        disabled
                        value={
                            isNullOrUndefined(notificationChannelName)
                                ? t('resources:NotificationEmail')
                                : notificationChannelName
                        }
                    />
                    <TextField
                        label={t('myProfile:Subscriptions')}
                        disabled
                        value={subscriptions}
                        title={subscriptions}
                    />
                    <TextField
                        label={t('myProfile:emailAddress')}
                        disabled={!isEditable}
                        required={isEditable}
                        value={currentProfile?.email}
                        validationFunc={(v) =>
                            required(t, v, t('myProfile:emailAddress'))
                        }
                        onChange={(_, v) =>
                            setCurrentProfile(
                                new TaxpayerRepresentativeDto({
                                    ...currentProfile,
                                    email: v ?? '',
                                })
                            )
                        }
                        onValidationChange={(isValid) => {
                            form.current.SetValidity('email', isValid);
                            form2.current.SetValidity('email', isValid);
                        }}
                    />
                    <TextField
                        label={t('myProfile:mobilePhone')}
                        className="mobilePhone"
                        required={isEditable}
                        disabled={!isEditable}
                        value={currentProfile?.mobileNo}
                        onChange={(_, v) =>
                            setCurrentProfile(
                                new TaxpayerRepresentativeDto({
                                    ...currentProfile,
                                    mobileNo: v ?? '',
                                })
                            )
                        }
                        onValidationChange={(isValid) => {
                            form.current.SetValidity('mobileNo', isValid);
                            form2.current.SetValidity('mobileNo', isValid);
                        }}
                        validationFunc={(v) =>
                            required(t, v, t('myProfile:mobilePhone'))
                        }
                    />
                </div>
            </Panel>
            <Panel title={t('myProfile:linkedTaxPayers')} allowEdition={false}>
                <TaxPayersGrid
                    items={taxpayerRepresentations}
                    currentLanguage={propsCurrentLanguage}
                    onActionClick={(id: number) => {
                        selectedRepresentationID.current = id;
                        setHiddenRepresentationDialog(false);
                    }}
                />
            </Panel>
            {!hiddenRepresentationDialog && (
                <RepresentationProvider>
                    <ViewRepresentation
                        onClose={() => {
                            setHiddenRepresentationDialog(true);
                            selectedRepresentationID.current = undefined;
                        }}
                        hidden={hiddenRepresentationDialog}
                        representationID={selectedRepresentationID.current}
                    />
                </RepresentationProvider>
            )}
            {!hiddenNotificationDialog && (
                <NotificationDialog
                    hidden={hiddenNotificationDialog}
                    onClose={hideNotificationDialog}
                    notifications={currentNotification}
                    onSave={onSaveNotificationDialog}
                />
            )}
            {!hiddenMobileDialog && (
                <Mobile
                    hidden={hiddenMobileDialog}
                    onClose={hidenMobileDialog}
                    NewMobile={currentProfile?.mobileNo}
                    onSave={onSave}
                    Type="User"
                    preferredLanguage={
                        preferredLanguage === LanguagesCodes.En
                            ? LanguageTypes.En
                            : LanguageTypes.Ar
                    }
                />
            )}

            {!hiddenMobileEmailDialog && (
                <EmailMobile
                    hidden={hiddenMobileEmailDialog}
                    onClose={hidenMobileEmailDialog}
                    NewMobile={currentProfile?.mobileNo}
                    NewEmail={currentProfile?.email}
                    onSave={onSave}
                    Type="User"
                    preferredLanguage={
                        preferredLanguage === LanguagesCodes.En
                            ? LanguageTypes.En
                            : LanguageTypes.Ar
                    }
                />
            )}
            {!hiddenEmailDialog && (
                <Email
                    hidden={hiddenEmailDialog}
                    onClose={hidenEmailDialog}
                    NewEmail={currentProfile?.email}
                    onSave={onSave}
                    Type="User"
                    preferredLanguage={
                        preferredLanguage === LanguagesCodes.En
                            ? LanguageTypes.En
                            : LanguageTypes.Ar
                    }
                />
            )}
        </LayoutContent>
    );
};

export default connector(MyProfile);
